import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Extract Behavior",
    desc: "Analyze legacy code & runtime behavior to capture real business logic.",
  },
  {
    n: "02",
    title: "Generate Assets",
    desc: "Create independent test cases covering edge cases & failure scenarios.",
  },
  {
    n: "03",
    title: "Parallel Run",
    desc: "Continuously validate modernized components against legacy behavior.",
  },
  {
    n: "04",
    title: "Detect Early",
    desc: "Identify mismatches immediately, when they are cheapest to fix.",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid="how-it-works"
      className="relative border-b border-white/10 bg-obsidian"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="chip text-neon-green">&gt; /process</div>
            <h2 className="mt-3 font-display font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tighter leading-[0.95]">
              How our verification-first engine works.
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/60 leading-relaxed text-sm">
            Whether it's modernization, development, or AI engineering, the
            same four-step engine runs underneath. Measurable. Accountable.
            Defensible.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-0 border-t border-l border-white/10">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative border-r border-b border-white/10 p-8 bg-carbon hover:bg-[#101010] transition-colors group"
              data-testid={`how-step-${s.n}`}
            >
              <div className="font-display font-black text-6xl text-neon-green/20 group-hover:text-neon-green/50 transition-colors">
                {s.n}
              </div>
              <h3 className="mt-4 font-display font-bold text-white text-xl">
                {s.title}
              </h3>
              <p className="mt-2 text-sm text-white/60 leading-relaxed">
                {s.desc}
              </p>
              <div className="absolute top-0 left-0 right-0 h-[1px] bg-neon-green/0 group-hover:bg-neon-green/60 transition-colors" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
